import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type FastApiService from 'walden-fast/services/fast-api';
import type { ConnectInterface } from 'walden-fast/types/connect-interface';
import type UserService from 'walden-fast/services/user';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppServicesWaldenConnectClientModel = Resolved<
  ReturnType<AppServicesWaldenConnectClientRoute['model']>
>;

type WaldenConnectClientRouteParams = {
  client_name_local: string;
};

export default class AppServicesWaldenConnectClientRoute extends Route {
  @service('fast-api') declare fastApiService: FastApiService;
  @service('user') declare userService: UserService;

  async model(params: WaldenConnectClientRouteParams) {
    const userCanAccessService = this.userService.canAccessService(
      SERVICE_NAMES.WALDEN_CONNECT,
    );

    const requestParams = { cnl: params.client_name_local };

    const rawInterfaces: ConnectInterface[] = userCanAccessService
      ? ((await this.fastApiService.get<ConnectInterface[]>(
          '/connect/logistics-interfaces',
          requestParams,
        )) ?? [])
      : [];

    const interfacesSortedByActive = [...rawInterfaces].sort((a, b) => {
      if (a.isActive && !b.isActive) return -1;
      if (!a.isActive && b.isActive) return 1;
      return 0;
    });

    return {
      interfaces: interfacesSortedByActive,
    };
  }
}
